import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "edil-admin-token";

export function getAdminToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function setAdminToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
}

export const adminApi = axios.create({ baseURL: API, timeout: 30000 });
adminApi.interceptors.request.use((cfg) => {
  const t = getAdminToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      setAdminToken(null);
      if (typeof window !== "undefined" && !window.location.pathname.endsWith("/albertoadimpannello")) {
        window.location.href = "/albertoadimpannello";
      }
    }
    return Promise.reject(err);
  }
);
